// Metadatos compartidos de especialidades Vortex (jerarquías, cuerpos/servicios,
// especialidades). Antes duplicados en VortexDocs.jsx / Vault.jsx; se centralizan
// aquí para reutilizarlos en los paneles admin de Vortex Academy.

export const RTDB_TO_FIRESTORE_HIERARCHY = {
  '0': 'MRO', '1': 'CBO', '2': '3RM', '3': '2DM', '4': '1RM', '5': 'TTE.CORB.', '6': 'TTE.FRAG.', '7': 'TTE.NAV.', '8': 'CAP.CORB.'
};

export const RTDB_TO_FIRESTORE_CORPS = {
  '0': 'CG', '1': 'IM', '2': 'AN', '3': 'MN'
};

export const RTDB_TO_FIRESTORE_SERVICES = {
  '0': 'SAIN', '1': 'SAN', '2': 'ING', '3': 'JUS', '4': 'DOC', '5': 'TS', '6': 'MUS', '7': 'SG'
};

export const SPECIALTY_NAME_TO_CODE = {
  'Oficinista': 'OFTA', 'Oficinistas': 'OFTA', 'Infanteria de Marina': 'IM', 'Infantería de Marina': 'INFANTERÍA DE MARINA', 'Lavandería': 'LAVD', 'Cocina': 'COCN',
  'Armamento': 'ARMM', 'Navegación': 'NAVG', 'Condestable': 'COND', 'Mecánico': 'MEC', 'Electricista': 'ELEC',
  'Electrónica': 'ELTC', 'Torpedos': 'TORP', 'Comunicaciones': 'COM', 'Radar': 'RAD', 'Sonar': 'SON',
  'Contramedidas': 'CMED', 'Piloto Aviador Naval': 'PAN', 'Observador Aéreo': 'OAN', 'Técnico Aeronáutico': 'TAN',
  'Fusilero': 'FUS', 'Artillero': 'ART', 'Médico': 'MED', 'Enfermero': 'ENF', 'Odontólogo': 'ODO', 'Farmacéutico': 'FAR',
  'Costurero': 'COSTR', 'Sastre': 'SSTR', 'Chofer': 'CHOFR', 'Lavandero': 'LAVDR', 'Jardinero': 'JRDNR',
  'Servicios Generales de alimentacion': 'SGA', 'impresor': 'IMPR', 'Camarero': 'CMRR', 'Cocinero': 'COCN',
  'Panadero': 'PNDR', 'Peluquero': 'PLQR', 'Armamento Aereo': 'ARMM_AER', 'Mecánico de Aviación': 'MEC_AVI',
  'Electrónico de Aviación': 'ELE_AVI', 'Operaciones Aereas': 'OPE_AER', 'Controlador de Vuelo': 'CTRL_VLO',
  'Contramaestres': 'CONTRAM', 'Condestables': 'CONDEST', 'Maquinas': 'MAQ', 'Trabajos Submarinos': 'TRAB_SUB',
  'Proteccion Portuaria': 'PROT_PORT', 'Informatico': 'INF', 'Radio Operador': 'RAD_OP', 'Mecánico Automotriz': 'MEC_AUTO',
  'Hidrografía': 'HIDRO', 'Informática/Computación': 'INF_COMP', 'carpintero ': 'CRPNT', 'Tornero': 'TRNR',
  'Soldador': 'SLDR', 'Electromecanico': 'E_MEC', 'Fontanero': 'FONT', 'Criminalistica': 'CRIM',
  'Licenciado en Derecho': 'DER', 'Mecánicos/Motoristas': 'MEC_MOT', 'Electricistas': 'ELEC',
  'Frigoríficos': 'FRIG', 'Control de Averías': 'CTRL_AV', 'Electrónicos': 'ELECTRON', 'Médicos Cirujanos': 'MED_CIR',
  'Cirujanos Dentistas': 'CIR_DENT', 'Enfermería': 'ENF', 'Psicología': 'PSIC', 'Nutrición': 'NUTR', 'Sanidad': 'SAN',
  'camillero ': 'CAMILL', 'Servicios Generales de Sanidad': 'SGS', 'Químico': 'QUIM', 'Dentista': 'DENT',
  'Radiologo': 'RADIO', 'Laboratorista': 'LAB', 'Licenciada en Pedagogia': 'PEDAG', 'Licenciada en Educacion Preescolar': 'EDUC_PRE',
  'Licenciada en Educacion Primaria': 'EDUC_PRIM', 'Alimentación': 'ALIM', 'Servicios Generales': 'SG',
  'Servicio de Trabajo Social Naval': 'TSN'
};

export const getRTDBPrefix = (inst) => {
  return (!inst || inst === 'SEMAR') ? '' : `content/${inst.toLowerCase()}`;
};

export const createBidirectionalMap = (metadataObject) => {
  const nameToCode = {};
  const codeToName = {};
  Object.entries(metadataObject).forEach(([code, value]) => {
    const name = typeof value === 'object' ? (value.nombre || code) : value;
    const upperCode = code.toUpperCase();
    nameToCode[name] = upperCode;
    nameToCode[name.toUpperCase()] = upperCode;
    nameToCode[code] = upperCode;
    nameToCode[upperCode] = upperCode;
    codeToName[upperCode] = name;
  });
  return { nameToCode, codeToName };
};

export const normalizeCode = (value, mappingObject) => {
  if (!value) return null;
  const directMatch = mappingObject[value];
  if (directMatch) return directMatch;
  const upperValue = value.toUpperCase();
  const upperMatch = mappingObject[upperValue];
  if (upperMatch) return upperMatch;
  return upperValue;
};
